<template>
  <div v-if="pageConfig" class="trial-page">
    <!-- 用户无购买权限 -->
    <Forbid
      v-if="!hasPermission"
      :desc="forbidDesc"
      :isLimit="pageConfig.is_limit"
    ></Forbid>

    <!-- 用户有购买权限 -->
    <TemplatePreset
      v-else
      :agreementTip="agreementTip"
      :agreementType="pageConfig.agreement_type"
      :agreementTitles="agreements"
      :defaultSelectStatus="defaultSelectStatus"
      :stopScroll="isFinish"
      :isShowAgreementSelect="!isApplySuccess"
      :canShowAgreeBomBar="
        (bottomConfig.config && !bottomConfig.config.coupon_image_url) ||
        hadGetCoupon
      "
      @initAgreements="handleInitAgreements"
      @agree-change="
        (agree) => {
          isAgree = agree;
        }
      "
    >
      <div slot="main" class="trial">
        <notice-bar
          v-if="pageConfig.notice_check && canApply"
          :id="$route.params.id"
        />

        <ProxyImg v-if="pageConfig.header" :img="pageConfig.header"></ProxyImg>

        <!-- 涨价倒计时 -->
        <ProxyImg
          v-if="priceCountDown && pageConfig.content"
          :img="pageConfig.content[0].data[0]"
        >
          <CountDown :count="priceCountDown" />
        </ProxyImg>

        <!-- 如开启了手机号验证，手机号验证模块插在第一张图与第二张图之间 -->
        <div
          v-for="(item, index) in pageConfig.content"
          :id="index === 1 && hasMobileModule ? 'mobile-wrapper' : ''"
          :key="index"
          class="comp-wrapper"
        >
          <valid-phone
            v-if="index === 1 && hasMobileModule"
            :isAgree="isAgree"
            :validPhone="pageConfig.mobile"
            :messageType="pageConfig.business_type"
            :btnColor="pageConfig.mobile_button_color"
            :bg="item.data[1]"
            :btnText="validPhoneText"
            @apply="handleApply"
            @valid-success="handleValidSucces"
          />
          <!-- 第二张图[]的第二项是手机号模块背景，只展示item.data[0] -->
          <component
            :is="compMap[item.type]"
            v-if="!priceCountDown || (priceCountDown && index !== 0)"
            ref="resList"
            :data="index === 1 ? [item.data[0]] : item.data"
            :productionId="productionId"
            @track-btn-click="$emit('track-btn-click', arguments[0])"
          >
          </component>
        </div>

        <template
          v-if="pageConfig.class_content && pageConfig.class_content.length"
        >
          <div
            v-for="(item, index) in pageConfig.class_content"
            :key="`class-${index}`"
            class="comp-wrapper"
          >
            <!-- 课程缩略，默认情况下只展示第一张 -->
            <component
              :is="compMap[item.type]"
              v-show="showAllClassIntroduce ? true : index === 0"
              :data="index === 1 ? [item.data[0]] : item.data"
              :productionId="productionId"
              @track-btn-click="$emit('track-btn-click', arguments[0])"
            ></component>
          </div>
          <div
            v-if="!showAllClassIntroduce"
            class="icon-more-wrap"
            @click="showAllClassIntroduce = true"
          >
            <div class="icon-more">
              了解详情
              <div class="icon-down" />
            </div>
          </div>
        </template>
      </div>

      <!-- 如果手机号验证模块在可视区中，不显示底部按钮 -->
      <div v-show="!isShowMobileValid" slot="bottom" class="bottom-wrapper">
        <component
          :is="currentBottomComp"
          v-show="
            (bottomConfig.config && !bottomConfig.config.coupon_image_url) ||
            hadGetCoupon
          "
          ref="bottom"
          :config="bottomConfig.config"
          :type="bottomConfig.type"
          :isAgree="isAgree"
          :isFinish="isFinish"
          :hasTimer="hasTimer"
          :deadline="bottomConfig.config && bottomConfig.config.dead_time"
          :deadlineText="bottomConfig.config && bottomConfig.config.document"
          :bgColor="pageConfig.button_color"
          :priceCountDown="priceCountDown"
          processBg="linear-gradient(135deg, #4C38CD 0%, #E600E7 100%)"
          @apply="handleApply"
          @go-url="handleGoUrl"
          @success-modal="handleOpenModal"
          @stopCount="refresh"
        ></component>
      </div>

      <!-- 支付方式模块 -->
      <template slot="container-absolute-item">
        <ChannelSwitch
          v-if="
            !pageConfig.payment_check &&
            canApply &&
            (!bottomConfig.config.coupon_image_url || hadGetCoupon) &&
            !isShowMobileValid &&
            !isFreePrice
          "
          :canSelect="supportType.length > 1"
          :config="payConfig"
          class="switch"
          @change="isShowPayChannel = true"
        ></ChannelSwitch>
        <ModalChannelSelect
          v-if="
            !pageConfig.payment_check &&
            canApply &&
            (!bottomConfig.config.coupon_image_url || hadGetCoupon) &&
            !isShowMobileValid &&
            !isFreePrice
          "
          :toggle="isShowPayChannel"
          :supportType="supportType"
          :useAbsolutePosition="true"
          :defaultType="defaultPayType"
          :huabeiList="huabeiList"
          :huabeiTotalAmount="huabeiTotalAmount"
          @change="onChangeChannel"
          @close="isShowPayChannel = false"
        ></ModalChannelSelect>
      </template>

      <template slot="fix-items">
        <PopupTipSuccess
          :textConfig="popupConfig"
          :isShow="isShowSuccessPopup"
          :closable="popupConfig.closable"
          @close="isShowSuccessPopup = false"
        ></PopupTipSuccess>
        <!-- 活动说明 -->

        <activity-rule v-if="pageConfig.rule" :rule="pageConfig.rule" />
      </template>
    </TemplatePreset>
    <CouponModal
      ref="couponModal"
      :productionId="productionId"
      :src="bottomConfig.config && bottomConfig.config.coupon_image_url"
      @getCouponSuccess="getCouponSuccess"
    />
    <component
      :is="
        questionCompMap[pageConfig.survey_type || 'idp_class'] ||
        questionCompMap.idp_class
      "
      :isShow="isShowQuestionnaire"
      :surveyCode="questionSurveyCode"
      @refresh="onQuestionnaireFinish"
    />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import TemplatePreset from '@/modules/common/TemplatePreset.vue';
import StaticContent from '../../flashcode/components/StaticContent.vue';
import BottomApply from './components/Apply.vue';
import BottomProcess from '../../flashcode/components/Process.vue';
import { Route } from 'vue-router';
import PopupTipSuccess from '@/modules/common/PopupTipSuccess';
import ProxyImg from '@/modules/common/ProxyImg';
import Forbid from '../Forbid.vue';
import ScrollTracker from '@/lib/ScrollTracker';
import CouponModal from './components/CouponModal.vue';
import EnrollmentMixin from '../mixins/EnrollmentMixin';
import {
  IPayType,
  ModalChannelSelect,
  ChannelSwitch,
  allChannels,
  PayTypes,
} from '@/modules/common/MutiPayChannel';
import {
  IAgreement,
  IBottom,
  IUserData,
  IPageConfig,
  BottomType,
  IApplyConfig,
} from '../types';
import validPhone from '../components/ValidPhone.vue';
import activityRule from '../components/ActivityRule.vue';
import noticeBar from '../components/NoticeBar.vue';
import CountDown from './components/CountDown.vue';

@Component({
  components: {
    TemplatePreset,
    StaticContent,
    BottomApply,
    PopupTipSuccess,
    ProxyImg,
    Forbid,
    ChannelSwitch,
    ModalChannelSelect,
    CouponModal,
    validPhone,
    activityRule,
    noticeBar,
    CountDown,
  },
  beforeRouteEnter(to: Route, from: Route, next: Function) {
    window.Al.start();
    window.np.start();
    Promise.all([
      window.apis.getGroupInfo({
        ...to.params,
        ...to.query,
        production_id: to.params.id,
      }),
      window.apis.getGroupUser({
        ...to.params,
        ...to.query,
        production_id: to.params.id,
      }),
    ])
      .then(([productionRes, userRes]) => {
        if (productionRes.data.in_activity) {
          next((vm: Group) => {
            const query: Record<string, string> = {
              ...to.query,
              production_id: productionRes.data.production_id,
            };

            vm.$router.push({
              name: 'DoubleEleven2021',
              query,
            });
          });
        } else if (userRes.data && userRes.data.success_url) {
          next(() => {
            window.location.replace(userRes.data.success_url);
          });
        } else {
          next((vm: Group) => {
            vm.handleSetPageTitle(productionRes.data.index_title);
            vm.initResource(productionRes.data, userRes.data);
            window.Al.done();
            window.np.done();
          });
        }
      })
      .catch((e) => {
        console.log('init', e);
      });
  },
})
export default class Group extends Mixins(EnrollmentMixin) {
  $refs!: {
    bottom: {
      handleUserAction: Function;
    };
    content: StaticContent;
    couponModal: StaticContent;
    resList: any;
  };
  pageConfig: IPageConfig | null = null;
  isAgree = true;
  productionId = 0;
  bottomConfig: IBottom = {
    type: BottomType.APPLY,
    config: null,
  };
  isShowSuccessPopup = false;
  popupConfig: any = {};
  isForbidScroll = false;
  hasPermission = true;

  isShowPayChannel = false;
  payConfig: IPayType = allChannels['wechat'];
  supportType: PayTypes[] = [];
  defaultPayType: PayTypes = PayTypes.wechat;
  agreements: string[] = [];
  hadGetCoupon = false;

  showAllClassIntroduce = false;
  // 涨价倒计时
  priceCountDown = 0;

  get currentBottomComp() {
    return this.bottomConfig.type === BottomType.APPLY
      ? BottomApply
      : BottomProcess;
  }
  get isFinish() {
    return this.bottomConfig.type === BottomType.FINISH;
  }
  get isApplySuccess() {
    return this.bottomConfig.type !== BottomType.APPLY && !this.isFinish;
  }
  get canApply() {
    return this.bottomConfig.type === BottomType.APPLY;
  }
  get agreementTip() {
    return `请阅读并勾选${this.agreements.join(' ')}`;
  }

  get forbidDesc() {
    if (this.pageConfig && this.pageConfig?.is_limit) {
      return ['您已购买一门课程，不能购买组合课'];
    }
    return ['很抱歉，该课程还在小规模内测阶段', '测试完成后将会开放，敬请期待'];
  }

  get defaultSelectStatus() {
    if (!this.canApply) {
      return true;
    }

    return this.pageConfig?.agreement_check || false;
  }

  get hasTimer() {
    const dead_time = (this.bottomConfig?.config as IApplyConfig)?.dead_time;
    return (
      (this.isAgree &&
        dead_time &&
        Number(dead_time) * 1000 > new Date().getTime()) ||
      this.priceCountDown > 0
    );
  }

  mounted() {
    window.history.pushState('', '', window.location.href);
    setTimeout(() => {
      const ele = document.getElementById('t-scroll-container');
      if (ele) {
        new ScrollTracker((s, e) => {
          this.__trackScrollPageview(s, e);
        }, ele).register();
      }
    });
  }

  refresh() {
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  }

  init() {
    this.toggleCouponModal(false);
    window.Al.start();
    window.np.start();
    Promise.all([
      window.apis.getGroupInfo({
        ...this.$route.params,
        ...this.$route.query,
        production_id: this.$route.params.id,
      }),
      window.apis.getGroupUser({
        ...this.$route.params,
        ...this.$route.query,
        production_id: this.$route.params.id,
      }),
    ])
      .then(([productionRes, userRes]) => {
        if (userRes.data && userRes.data.success_url) {
          window.location.replace(userRes.data.success_url);
        } else {
          this.initResource(productionRes.data, userRes.data);
          window.Al.done();
          window.np.done();
        }
      })
      .catch((e) => {
        console.log('init', e);
      });
  }

  toggleCouponModal(status: boolean) {
    this.$nextTick(() => {
      const couponModal = this.$refs.couponModal;
      if (couponModal) {
        couponModal.toggleModal(status);
      }
    });
  }
  getCouponSuccess() {
    this.hadGetCoupon = true;
  }

  initResource(data: IPageConfig, userData: IUserData) {
    if (data.redirect_url) {
      window.location.replace(data.redirect_url);
      return;
    }
    this.hasPermission = !data.is_limit && data.permission;
    this.productionId = data.production_id;

    // 初始化分享信息
    if (data && data.share) {
      const share = data.share;
      this.$initShare(() => {
        window.wx.ready(() => {
          window.wx.onMenuShareTimeline(share.timeline);
          window.wx.onMenuShareAppMessage(share.app_message);
        });
      });
    }

    // 无资格，展示无资格页面
    if (!this.hasPermission) {
      this.pageConfig = data;
      return;
    }

    this.initUser(userData);
    this.pageConfig = data;

    // 优惠券弹窗
    if (
      (userData.bottom.config as IApplyConfig)?.coupon_image_url &&
      Number(this.priceCountDown) === 0
    ) {
      this.toggleCouponModal(true);
    }

    const config = userData.bottom.config;
    const payment_configs = data.payment_configs;
    if (payment_configs) {
      this.defaultPayType =
        data.default_payment || payment_configs[0] || PayTypes.wechat;
      this.payConfig = allChannels[this.defaultPayType];
      this.supportType = payment_configs;
    }

    this.handleTrack();
    this.handleTrackResList();
    this.handleObserverMobile();
  }
  initUser(data: IUserData) {
    this.couponId = data.coupon_id;
    this.bottomConfig = data.bottom;
    this.priceCountDown = data.countDown || 0;

    if (!this.canApply) {
      this.handleRecordCoupon();
    }

    this.$nextTick(() => {
      if (this.bottomConfig?.config?.show) {
        this.$refs.bottom.handleUserAction();
      }
    });
  }

  handleGoUrl(config: { url: string; button: string }) {
    this.__trackBtnLeave({
      button_name: config.button,
    });
    if (config.url) {
      setTimeout(() => {
        window.location.href = config.url;
      }, 300);
    }
  }
  handleOpenModal(config: { modal: any }) {
    this.popupConfig = config.modal;
    this.isShowSuccessPopup = true;
  }

  freshBottomConfig() {
    return window.apis
      .getGroupUser({
        ...this.$route.params,
        ...this.$route.query,
        production_id: this.$route.params.id,
      })
      .then((res: any) => {
        if (res.data && res.data.success_url) {
          window.location.replace(res.data.success_url);
        } else {
          this.initUser(res.data);
        }
      })
      .catch((e: any) => {
        console.log('freshBottomConfig', e);
      });
  }

  handleInitAgreements(res: IAgreement[]) {
    if (res.length) {
      this.agreements = res.map((agreement: IAgreement) => agreement.title);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/helps.scss';
@import '@/style/animate.scss';
.switch {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 3;
}
.trial-page {
  width: 100%;
  height: 100%;
}

.comp-wrapper {
  position: relative;
}

@include pulse;
.animate-pluse {
  animation-name: pulse;
  animation-duration: 700ms;
  animation-iteration-count: infinite;
}
.icon-more-wrap {
  width: 100%;
  height: 220px;
  padding-top: 20px;
  background-color: rgb(220, 208, 251);

  .icon-more {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 189px;
    height: 46px;
    margin: 0 auto;
    color: #6823eb;
    font-weight: 600;
    font-size: 26px;
    line-height: 46px;
    text-align: center;
    border: 1px solid #884df3;
    border-radius: 23px;

    .icon-down {
      width: 0px;
      height: 0px;
      margin-top: 8px;
      margin-left: 10px;
      border: 9px solid transparent;
      border-top-color: #6823eb;
    }
  }
}
</style>


<style scoped>
.trial-page >>> .seat-img {
  width: 100vw;
}
</style>
